"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rightusageReducer = exports.rightusageActions = exports.TYPES = exports.INIT_STATE = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Rightusage';

// アクションタイプ
const TYPES = exports.TYPES = {
  // 検索条件変更
  CHANGE_CONDITION: PREFIX + 'ChangeCondtion',
  //　共有条件反映
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  // 検索結果を設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // 組織名の表示切替
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // 利用権限設定変更
  CHANGE_RIGHTUSAGE: PREFIX + 'ChangeRightusage',
  // ページングリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 全状態を初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// 初期状態
const INIT_STATE = exports.INIT_STATE = {
  conditions: {
    userNm: '',
    kaishaCd: '',
    soshikiCd: '',
    jobClass: '',
    roleId: '',
    label: ''
  },
  searchResult: [],
  roleList: [],
  listState: {},
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  soshikiShowAll: false
};
const rightusageActions = exports.rightusageActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      shareCondition: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      resultData: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_RIGHTUSAGE]: function () {
    return {
      userId: arguments.length <= 0 ? undefined : arguments[0],
      rightusage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_PAGING, TYPES.CLEAR);
const rightusageReducer = exports.rightusageReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      conditions: _objectSpread(_objectSpread({}, state.conditions), action.payload.shareCondition)
    });
  },
  [TYPES.SET_SEARCH_RESULT]: (state, action) => {
    let newListState = {};
    action.payload.resultData.userList.forEach(data => {
      newListState[data.kaishaCd + data.shainId] = {
        isChange: false,
        kaishaCd: data.kaishaCd,
        shainId: data.shainId,
        rightusage: data.roleId === null ? _CodeConsts.CODE.USAGE_RIGHTS.CODE_GENERAL : data.roleId,
        rightusageOrg: data.roleId,
        insert: data.roleId === null ? true : false
      };
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: action.payload.resultData.userList,
      listState: newListState,
      roleList: action.payload.resultData.roleList
    });
  },
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      soshikiShowAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_RIGHTUSAGE]: (state, action) => {
    let newListState = Object.assign({}, state.listState);
    const {
      rightusageOrg
    } = newListState[action.payload.userId];
    newListState[action.payload.userId] = _objectSpread(_objectSpread({}, newListState[action.payload.userId]), {}, {
      isChange: action.payload.rightusage !== rightusageOrg && !(action.payload.rightusage === _CodeConsts.CODE.USAGE_RIGHTS.CODE_GENERAL && rightusageOrg === null),
      rightusage: action.payload.rightusage,
      rightusageOrg: rightusageOrg
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listState: newListState
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);